import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影大全", to: "/category?type=movie" },
  { label: "电视剧大全", to: "/category?type=tv" },
  { label: "站内搜索", to: "/search" },
];

const aboutLinks = [
  { label: "关于我们", to: "/about" },
  { label: "使用须知", to: "/about#notice" },
  { label: "版权声明", to: "/about#notice" },
  { label: "意见反馈", to: "/about#feedback" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-300 border-t border-background-400/70 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-white text-lg">
                <i className="ri-film-line" />
              </span>
              <span className="text-[17px] font-bold text-foreground-950">嫩草影院</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-600 max-w-sm">
              嫩草影院是一个专注高清影视内容展示的平台，汇集电影、电视剧、纪录片等多元片库，为观众提供清晰的分类检索与剧情了解体验。本站内容均为虚构演示示例。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-movie-2-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 border border-background-400 text-foreground-600"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">服务支持</h4>
            <ul className="space-y-3">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <p className="text-sm text-foreground-600 leading-7">
              合作与内容反馈
              <br />
              <span className="text-foreground-900">hello@nevcao-cinema.demo</span>
            </p>
            <p className="mt-4 text-xs text-foreground-500 leading-6">
              演示站点，不提供真实播放服务。页面中的片名、评分与演职人员信息均为虚构内容。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-400/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            © 2026 嫩草影院 NEVCAO CINEMA · 本站内容仅用于产品演示
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <Link to="/about#notice" className="hover:text-primary-500 transition-colors">
              服务条款
            </Link>
            <Link to="/about#notice" className="hover:text-primary-500 transition-colors">
              隐私说明
            </Link>
            <span>高清 · 多端 · 易检索</span>
          </div>
        </div>
      </div>
    </footer>
  );
}